import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { API } from "../lib/api";

const OutletCtx = createContext(null);

export function OutletProvider({ children }) {
  const [outlets, setOutlets] = useState([]);
  const [outlet, setOutletState] = useState(() => {
    try { return JSON.parse(localStorage.getItem("svk_outlet") || "null"); } catch { return null; }
  });
  const [location, setLocationState] = useState(() => {
    try { return JSON.parse(localStorage.getItem("svk_location") || "null"); } catch { return null; }
  });

  useEffect(() => {
    API.get("/outlets").then((r) => {
      setOutlets(r.data);
      setOutletState((cur) => {
        if (cur && !r.data.some((o) => o.id === cur.id)) {
          localStorage.removeItem("svk_outlet");
          return null;
        }
        return cur;
      });
    }).catch(() => {});
  }, []);

  const persist = useCallback((o, loc) => {
    setOutletState(o);
    setLocationState(loc);
    if (o) localStorage.setItem("svk_outlet", JSON.stringify(o)); else localStorage.removeItem("svk_outlet");
    if (loc) localStorage.setItem("svk_location", JSON.stringify(loc)); else localStorage.removeItem("svk_location");
  }, []);

  const resolve = useCallback(async ({ pincode = "", city = "", lat = null, lng = null }) => {
    const { data } = await API.post("/location/resolve", { pincode, city, lat, lng });
    const loc = { pincode, city, label: pincode || city, serviceable: data.serviceable };
    persist(data.serviceable ? data.outlet : null, loc);
    return data;
  }, [persist]);

  const clearLocation = useCallback(() => persist(null, null), [persist]);
  const setOutlet = useCallback((o) => persist(o, o ? { label: o.name, serviceable: true } : null), [persist]);

  return (
    <OutletCtx.Provider value={{ outlets, outlet, location, resolve, clearLocation, setOutlet }}>
      {children}
    </OutletCtx.Provider>
  );
}

export const useOutlet = () => useContext(OutletCtx);
